import State from './State';
import Fetch from './Fetch';
import Filters from './Filters';

const List = ({ logout, losesAccess, message }) => {
  const state = State();
  
  Fetch({
    logout,
    setActivities: state.setActivities,
    setLoading: state.setLoading,
    message
  });

  const filters = Filters({
    activities: state.activities,
    query: state.query,
    sortConfig: state.sortConfig,
    setSortConfig: state.setSortConfig,
    losesAccess,
  });

  return {
    ...state,
    ...filters,
  };
};

export default List;
